module.exports = __webpack_public_path__ + "static/Sarabande-62322b0ddbc1051a3edc688473c7c9c3.mp3";